import React, {
  useState,
  useRef,
  useEffect,
  useLayoutEffect,
  Fragment as _,
} from 'react';
import { Block, Blocks } from '@chameleoncreator/creator-app';
import getBlockById from 'services/apiHelpers/getBlockById';
import { findBlocksIn } from 'selectors/block';
import { State } from 'store/store';
import { createSelector } from 'reselect';
import { getAllScoringInteractions } from 'services/scoring';

export const getScoreDataFromScoringBlocks = state => {
  const { blocks } = state;
  /**
   * activeBlockSelector finds blocks that are accessible from the root block
   */
  const activeBlockSelector = (blocks: Blocks, rootId: string): Block[] => {
    return findBlocksIn(blocks, blocks[rootId], (i: any) => i);
  };

  /**
   * scoringBlocks finds all the blocks that are scorable and have it turned on
   */
  const scoringBlocks = (blocks: Block[]): string[] => {
    return blocks
      .filter((b: any) => {
        return b?.props?.score && b.props.score === true;
      })
      .map((b: any) => b.id);
  };

  /**
   * This selector pulls out all the active blocks from the store
   */
  const loadActiveBlocks = createSelector(
    [(state: State) => state.blocks, (state: State) => state.rootBlockId!],
    activeBlockSelector
  );

  const loadScoringBlocks = createSelector(loadActiveBlocks, scoringBlocks);

  const getModuleBlock = createSelector(
    // (state: State) => state.blocks,
    () => blocks,
    (blocks: Blocks) => Object.values(blocks).find(b => b.type === 'Module')
  );

  const moduleBlock = (Object.values(blocks as Block[]).find(
    (b: Block) => b.type === 'Module'
  ) || {}) as Block;
  let mbProps = { passMark: 80 };

  if (moduleBlock) {
    mbProps = moduleBlock.props as { passMark: number };
  }

  const scoreData = state.userBehaviour.score;
  const passMark = mbProps.passMark;

  const scoringInteractions = loadScoringBlocks(state);
  const numberOfScorableInteractions = scoringInteractions.length;

  const allScoringInteractions = getAllScoringInteractions();

  const getScoreDataFromScoringInteractions = scoreData => {
    if (!scoreData) {
      return {};
    }

    return allScoringInteractions.reduce((acc, curr) => {
      return {
        ...acc,
        ...(scoreData?.[curr] && {
          [curr]: !!scoreData[curr] ? 1 : 0,
        }),
      };
    }, {});
  };

  const scoreDataFromScoringInteractions = getScoreDataFromScoringInteractions(
    scoreData
  );

  const scoreRaw = Object.values(
    // scoringByTopic ? topicScoreData : scoreData
    scoreDataFromScoringInteractions
  ).reduce<number>((acc, curr) => acc + Number(curr), 0);

  const scorePercent =
    ((scoreRaw || 0) / numberOfScorableInteractions) * 100 || 0;

  const hasScoringInteractions = !!allScoringInteractions?.length;
  // !!getAllScoringInteractions().length;

  const passed = hasScoringInteractions
    ? scorePercent >= Number(passMark)
    : true;

  const score = hasScoringInteractions ? scorePercent.toFixed() : 100;

  return {
    score,
    passed,
  };
};
